import { ProfilingDataType } from './types';
import { formatNumber, millisecondToISODate } from '../common/utils';
import { DEFAULT_DATE_FORMAT } from '../common/constants';
export var percentString = function (amount, total) { return (amount / total * 100).toFixed(1) + "%"; };
/**
 * Returns a relative position of value within the range <min, max>. E.g. value: 5, min: 0, max: 10 => '50%'
 */
export var positionInRange = function (value, min, max) {
    var total = max - min;
    var amount = value - min;
    return percentString(amount, total);
};
/**
 * Return an array with max length {MAX_LABELS_COUNT}. The items are numbers uniformly spaced between 0 and maxValue (param)
 */
export var getHistogramYAxisValues = function (maxValue, maxLabelsCount) {
    if (maxLabelsCount === void 0) { maxLabelsCount = 10; }
    var intervalWidth = maxValue <= maxLabelsCount
        ? 1
        : Math.ceil(maxValue / maxLabelsCount);
    var numberOfLabels = Math.ceil(maxValue / intervalWidth);
    var labels = [0];
    for (var i = 1; i <= numberOfLabels; i++) {
        labels.push(i * intervalWidth);
    }
    return labels;
};
export var getLabelsAlignmentsForStatisticChart = function (min, max, axisMin, axisMax, secondDotValue, thirdDotValue) {
    var TWO_DOTS_MINIMUM_DISTANCE = 7; // in %. Box & Whisker Chart
    // determine if 3rd dot is too close to MIN or MAX dot
    var onePercentStep = (max - axisMin) / 100;
    var isThirdDotTooCloseToStart = thirdDotValue ? (thirdDotValue - min) / onePercentStep < TWO_DOTS_MINIMUM_DISTANCE : false;
    var isThirdDotTooCloseToEnd = thirdDotValue ? (max - thirdDotValue) / onePercentStep < TWO_DOTS_MINIMUM_DISTANCE : false;
    var minLabelAlign = axisMin === min ? 'left' : 'center';
    var maxLabelAlign = axisMax === max ? 'right' : 'center';
    var secondDotLabelAlign = 'center';
    var thirdDotLabelAlign = 'center';
    if (isThirdDotTooCloseToStart) {
        minLabelAlign = 'right';
        thirdDotLabelAlign = 'left';
    }
    else if (isThirdDotTooCloseToEnd) {
        maxLabelAlign = 'left';
        thirdDotLabelAlign = 'right';
    }
    return { minLabelAlign: minLabelAlign, maxLabelAlign: maxLabelAlign, secondDotLabelAlign: secondDotLabelAlign, thirdDotLabelAlign: thirdDotLabelAlign };
};
export var formatLabel = function (value, type) {
    switch (type) {
        case ProfilingDataType.BOOLEAN_TYPE:
            return typeof value === 'boolean'
                ? (Boolean(value) ? 'TRUE' : 'FALSE')
                : value;
        case ProfilingDataType.TIME_TYPE:
            // return formatted date if we have number, otherwise return value as is (e.g. can be 'Null' text)
            return !isNaN(value)
                ? millisecondToISODate(value, undefined, DEFAULT_DATE_FORMAT)
                : value;
        case ProfilingDataType.NUMBER_TYPE:
            return isNaN(value)
                ? value
                : formatNumber(+value);
        case ProfilingDataType.LITERAL_TYPE:
        default:
            return value;
    }
};
//# sourceMappingURL=utils.js.map